var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "w-full px-4 hl-header-container" };
const _hoisted_2 = { class: "flex items-center justify-content-between" };
const _hoisted_3 = { class: "hl-media-title title title-extra-slots hl-display-sm-medium" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "hl-media-actions" };
const _hoisted_6 = { class: "flex items-center" };
const _hoisted_7 = {
    key: 0,
    lass: "flex items-center"
};
const _hoisted_8 = {
    key: 1,
    class: "flex items-center"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
import useEmitter from '@/composable/useEmitter';
import MediaServices from '@/services/MediaService';
import { useStore } from '@/store';
import { CustomContentAiIcon } from '@gohighlevel/ghl-icons/24/custom';
import { FolderPlusIcon, PlusIcon, Server01Icon, Upload01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIBreadcrumb, UIBreadcrumbItem, UIButton, UIDropdown, UIHeader, UISpin, UITextSmMedium, UITooltip, } from '@gohighlevel/ghl-ui';
import { h, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaHeaderv2',
    props: {
        currentFolderLevel: Object,
        contentAIEnable: Boolean,
        showContentAI: Boolean,
    },
    emits: ["uploadMedia", "createFolder", "openImageGenerationForm", "onClickFolder"],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const emit = __emit;
        const primaryOptionSection = e => {
            switch (e) {
                case 'upload_file':
                    emit('uploadMedia');
                    break;
                case 'new_folder':
                    emit('createFolder');
                    break;
                default:
            }
        };
        const sortingOptions = [
            {
                label: 'Upload file',
                key: 'upload_file',
                icon() {
                    return h(renderIcon(Upload01Icon), null, {});
                },
            },
            {
                label: 'New Folder',
                key: 'new_folder',
                icon() {
                    return h(renderIcon(FolderPlusIcon), null, {});
                },
            },
        ];
        const store = useStore();
        const emitter = useEmitter();
        const storageUsage = ref();
        const storageUsageError = ref(false);
        const altId = store.altId;
        const altType = store.altType;
        const onClickFolder = (folder) => {
            emit('onClickFolder', folder);
        };
        const openImageAI = () => {
            emit('openImageGenerationForm');
        };
        function removeDuplicates(data) {
            const uniqueIds = new Set();
            const uniqueData = [];
            data.forEach(item => {
                if (!uniqueIds.has(item._id)) {
                    uniqueIds.add(item._id);
                    uniqueData.push(item);
                }
            });
            return uniqueData;
        }
        const calculateUsage = () => __awaiter(this, void 0, void 0, function* () {
            try {
                storageUsage.value = undefined;
                storageUsageError.value = false;
                if (altType === 'location') {
                    const { data } = yield MediaServices.getLocationUsage({
                        altId,
                        altType,
                    });
                    storageUsage.value = data === null || data === void 0 ? void 0 : data.usage;
                    storageUsageError.value = false;
                }
            }
            catch (error) {
                storageUsage.value = 0;
                storageUsageError.value = true;
            }
        });
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            calculateUsage();
            emitter.on('calculateStorage', calculateUsage);
        }));
        onBeforeUnmount(() => __awaiter(this, void 0, void 0, function* () {
            emitter.off('calculateStorage', calculateUsage);
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIHeader), {
                    id: "hl-media-center-main-header",
                    title: ""
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                (__props.currentFolderLevel.length == 1)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t('common.mediaStorage')), 1))
                                    : (_openBlock(), _createBlock(_unref(UIBreadcrumb), {
                                        key: 1,
                                        separator: ">"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(removeDuplicates(__props.currentFolderLevel), (folder, index) => {
                                                return (_openBlock(), _createBlock(_unref(UIBreadcrumbItem), { key: index }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UITextSmMedium), {
                                                            class: _normalizeClass([
                                                                index === __props.currentFolderLevel.length - 1
                                                                    ? 'cursor-default text-curious-blue-500'
                                                                    : 'text-gray-600',
                                                            ]),
                                                            onClick: ($event) => (onClickFolder(folder))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(folder === null || folder === void 0 ? void 0 : folder.name), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["class", "onClick"])
                                                    ]),
                                                    _: 2
                                                }, 1024));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }))
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    (_unref(altType) === 'location')
                                        ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                            key: 0,
                                            placement: "button",
                                            trigger: "hover"
                                        }, {
                                            trigger: _withCtx(() => [
                                                _createVNode(_unref(UIButton), {
                                                    id: "hl-media-used",
                                                    type: "default"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["flex items-center", { 'text-danger': storageUsageError.value }])
                                                        }, [
                                                            _createVNode(_unref(Server01Icon), { class: "h-4 w-4 mr-2" }),
                                                            (storageUsage.value || storageUsageError.value)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(storageUsageError.value
                                                                    ? _ctx.$t('common.calculationFailed')
                                                                    : storageUsage.value), 1))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('common.calculating')) + "... ", 1),
                                                                    _createVNode(_unref(UISpin), {
                                                                        show: true,
                                                                        size: 13,
                                                                        class: "ml-2"
                                                                    })
                                                                ]))
                                                        ], 2)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            default: _withCtx(() => [
                                                (storageUsageError.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('common.storageUsageErrorMessage')), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('common.storageUsageMessage')), 1))
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (__props.showContentAI)
                                        ? (_openBlock(), _createBlock(_unref(UIButton), {
                                            key: 1,
                                            id: "hl-image-ai-action",
                                            class: "flex items-center hl-image-ai-action ml-2",
                                            disabled: !__props.contentAIEnable,
                                            onClick: openImageAI
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(CustomContentAiIcon), { class: "h-4 w-4 mr-2" }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)('common.createAi')), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_unref(UIDropdown), {
                                        options: sortingOptions,
                                        id: "hl-media-upload-dropdown",
                                        trigger: "click",
                                        placement: "bottom",
                                        size: "medium",
                                        onSelect: primaryOptionSection
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(UIButton), {
                                                id: "hl-media-upload",
                                                type: "primary",
                                                class: "flex items-center ml-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(PlusIcon), { class: "h-4 w-4 mr-2" }),
                                                    _createTextVNode(" " + _toDisplayString(_unref(t)('common.newUpload')), 1)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
